module.exports = __webpack_public_path__ + "img/image-gallery-pop-up.cfc5f62b.png";